import styled from 'styled-components';

import { Checkbox } from 'components/uikit/Form/Checkbox/Checkbox';

import { FormGridRowBase } from '../../AnketaForm.styles';
import { AnketaInputMask, AnketaDaData, AnketaFormHeader } from '../../../MainAnketa.styles';

export const FormGridRow = styled(FormGridRowBase)`
  grid-template-areas:
    '. head head head head . . .'
    '. adrs adrs adrs adrs rd rd .'
    '. indx indx . . . . . '
    '. h h h h h h .'
    '. adrsLive adrsLive adrsLive adrsLive indxLive indxLive .'
    '. type type type rs rs rs .';
`;

export const FormHeader = styled(AnketaFormHeader)`
  grid-area: head;
  grid-template-areas: '. . . . . . . .';
  margin-bottom: 16px;
`;

export const FormPropertyRow = styled(FormGridRowBase)`
  grid-template-areas: '. lastate lastate lastate lastate . . .';
`;

export const Address = styled(AnketaDaData)`
  grid-area: adrs;
`;

export const Index = styled(AnketaInputMask)`
  grid-area: indx;
`;

export const RegistrationDate = styled(AnketaInputMask)`
  grid-area: rd;
`;

export const AddressLive = styled(AnketaDaData)`
  grid-area: adrsLive;
`;

export const IndexLive = styled(AnketaInputMask)`
  grid-area: indxLive;
`;

export const LivingAddressEqualsToogle = styled(Checkbox).attrs({ size: 'xs' })`
  grid-area: type;
`;

export const RealtyStateToogle = styled(Checkbox).attrs({ size: 'xs' })`
  grid-area: rs;
`;
